export var ThemeBranded;
(function (ThemeBranded) {
    ThemeBranded["Full"] = "full";
    ThemeBranded["OneColor"] = "one_color";
    ThemeBranded["Partial"] = "partial";
    ThemeBranded["No"] = "no";
})(ThemeBranded || (ThemeBranded = {}));
export var ThemeName;
(function (ThemeName) {
    ThemeName["Edgy"] = "Edgy";
    ThemeName["Posh"] = "Posh";
    ThemeName["Minimal"] = "Minimal";
    ThemeName["NoFilter"] = "No Filter";
    ThemeName["Christmas"] = "Christmas Greetings";
    ThemeName["Winter"] = "Winter";
    ThemeName["Spark"] = "Spark";
    ThemeName["Story"] = "Story";
    ThemeName["Duotone"] = "Duotone";
    ThemeName["Circle"] = "Circle";
    ThemeName["Sale"] = "Sale";
    ThemeName["Bubbles"] = "Bubbles";
    ThemeName["Frame"] = "Frame";
    ThemeName["Pixels"] = "Pixels";
    ThemeName["Moments"] = "Moments";
    ThemeName["Kids"] = "Kids";
    ThemeName["Fashion"] = "Fashion";
    ThemeName["Trigono"] = "Trigono";
    ThemeName["Brushstroke"] = "Brushstroke";
    ThemeName["Love"] = "XOXO";
    ThemeName["Glass"] = "Glass";
})(ThemeName || (ThemeName = {}));
export var SaveVideoStatus;
(function (SaveVideoStatus) {
    SaveVideoStatus["OK"] = "OK";
})(SaveVideoStatus || (SaveVideoStatus = {}));
export var SaveVideoProgressStatus;
(function (SaveVideoProgressStatus) {
    SaveVideoProgressStatus["OK"] = "OK";
    SaveVideoProgressStatus["FAIL"] = "FAIL";
})(SaveVideoProgressStatus || (SaveVideoProgressStatus = {}));
export var SaveVideoProgressStep;
(function (SaveVideoProgressStep) {
    SaveVideoProgressStep["REMIXING"] = "REMIXING";
    SaveVideoProgressStep["RENDERING"] = "RENDERING";
    SaveVideoProgressStep["DONE"] = "DONE";
})(SaveVideoProgressStep || (SaveVideoProgressStep = {}));
//# sourceMappingURL=VideoMakerApiPayload.js.map